import * as React from "react";
import { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Tooltip, Avatar, MenuItem, Menu } from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import ListItems from "./ListItems";
import { Outlet } from "react-router-dom";
import { axiosGet, axiosPost } from "../lib/api";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import { Password } from "@mui/icons-material";
import UserContext from "../UserContext";

const drawerWidth = 200;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: 2,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  zIndex: 1,

  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),

    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Layout() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const token = Cookies.get("spectransyscore_token");
  const userName = Cookies.get("spectransyscore_userName");
  const router = useNavigate();
  const location = useLocation();
  const pathname = location?.pathname;

  const [userData, setUserData] = useState([]);

  const handleDrawerOpen = () => {
    // setOpen(true);
    setOpen((prevOpen) => !prevOpen);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChangePass = () => {
    router("/change_password");
  };

  const logout = (e) => {
    e.preventDefault();
    const jsonStructure = {
      accessToken: token,
    };
    try {
      axiosPost
        .post("logout/", jsonStructure)
        .then((response) => {
          if (response.data.message === "Logout successful") {
            Cookies.remove("spectransyscore_token");
            Cookies.remove("spectransyscore_userName");
            Cookies.remove("spectransyscore_userType");
            // Cookies.remove("user_id");
            router("/login");
          }
        })
        .catch((error) => {
          console.error("POST Error:", error);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  // Function to fetch user data
  const fetchValidToken = async () => {
    axiosGet
      .get(`user/valid/token?userToken=${token}`)
      .then((response) => {
        if (response.data.status === "success") {
          // if (response.data.data !== undefined && response.data.data.length > 0) {
          setUserData(response?.data?.data);
        } else {
          Cookies.remove("spectransyscore_token");
          Cookies.remove("spectransyscore_userName");
          router("/login");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        console.log(error?.response.data,'g')
        if (error?.response?.data?.status === "error") {
          Cookies.remove("spectransyscore_token");
          Cookies.remove("spectransyscore_userName");
          router("/login");
        } else if (error?.response?.data?.error === "Invalid access token") {
          Cookies.remove("spectransyscore_token");
          Cookies.remove("spectransyscore_userName");
          router("/login");
        }
      });
  };
  useEffect(() => {
    fetchValidToken();
  }, [pathname]);
  useEffect(() => {
    fetchValidToken();
  }, []);

  // useEffect(() => {
  //   if (!token) {
  //     router("/login");
  //   }
  // }, [token]);

  if (!token) {
    return null;
  }
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        open={open}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 2.5,
              //   ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            textTransform={"uppercase"}
            fontFamily={"sans-serif"}
          >
            Spectransyscore
          </Typography>
        </Toolbar>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ mx: 2, height: "fit-content" }}
            aria-controls={menuOpen ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? "true" : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}>
              {userName?.charAt(0).toUpperCase()}
            </Avatar>
          </IconButton>
        </Tooltip>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={menuOpen}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Typography p={1} px={2} textTransform={"capitalize"}>
          {userName}
        </Typography>
        <Divider />
        {/* <MenuItem onClick={handleClose}>
          <Avatar /> Profile
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Avatar /> My account
        </MenuItem>
        <Divider /> */}
        <MenuItem
          onClick={handleChangePass}
          sx={{ fontSize: "12px", fontWeight: "600" }}
        >
          <ListItemIcon>
            <Password fontSize="small" />
          </ListItemIcon>
          Change Password
        </MenuItem>
        <MenuItem onClick={logout} sx={{ fontSize: "12px", fontWeight: "600" }}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <ListItems open={open} />
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, overflow: "auto" }}>
        <DrawerHeader />
        <UserContext.Provider value={userData}>
          <Outlet />
        </UserContext.Provider>
      </Box>
    </Box>
  );
}
